import React from "react";
import "./comp.css";
import tcs from "../../assets/tcs.png";
import nokia from "../../assets/nokia.png";
import hack from "../../assets/hack.png";

const Win = () => {
  return (
    <section id="comp">
      <h2 className="worksTitle">Competitions</h2>

      <div className="category">
        <div className="compGrid">

          {/* TCS Tech Bytes */}
          <div className="compCard">
            <img src={tcs} alt="TCS Tech Bytes" />
            <h4>TCS Tech Bytes</h4>
            <p>
              Advanced to the <b>Regional Round</b> of TCS Tech Bytes held at 
              <b> Mangalore</b> on <b>March 2025</b>.
            </p>
          </div>

          {/* Nokia Hackathon */}
          <div className="compCard">
            <img src={nokia} alt="Nokia Accelerate Her Hackathon" />
            <h4>Nokia Accelerate Her Hackathon</h4>
            <p>
              Selected for the <b>Grand Finale</b> of Nokia’s Hackathon 
              conducted in <b>February 2025</b>.
            </p>
          </div>

          {/* Smart India Hackathon */}
          <div className="compCard">
            <img src={hack} alt="Smart India Hackathon" />
            <h4>Smart India Hackathon</h4>
            <p>
              Participated in the <b>Zonal Round</b> of SIH 
              held in <b>August 2024</b>.
            </p>
          </div>

        </div>
      </div>
    </section>
  );
};

export default Win;
